import { apiFetch } from './apiFetch';

export async function resetPassword(mail, telefono, length = 12) {
  if (telefono === undefined && mail === undefined) {
    throw new Error(
      'resetPassword requiere un objeto: { telefono, mail, length }'
    );
  }

  return apiFetch(process.env.REACT_APP_RESET_PASSWORD, {
    method: 'POST',
    body: JSON.stringify({ telefono, mail, length }),
  });
}